import { CSSObject } from '@chakra-ui/react';

export const Accordion: CSSObject = {
  border: 'none',
  overflow: 'hidden',
  bg: 'gray.200',
  borderRadius: 'md',

  '.chakra-accordion__item': {
    _first: {
      borderTop: '0',
    },
    _last: {
      borderBottom: '0',
    },
  },

  '.chakra-accordion__panel': {
    color: 'gray.600',
  },
};

export const AccordionHeader: CSSObject = {
  bg: 'beta.600',
  color: 'white',
  transitionDuration: 'normal',
  transitionProperty: 'common',

  _hover: {
    bg: 'beta.700',
    color: 'white',
  },
  _focus: {
    bg: 'beta.700',
    color: 'white',
  },

  '.chakra-accordion__icon': {
    boxSize: '6',
  },
};

export const OverviewPromotionsPanel: CSSObject = {
  color: 'white',

  '.chakra-checkbox__control': {
    borderRadius: 'xs',
    border: '1px solid black',
  },
};

export const AccordionHeaderLogOut: CSSObject = {
  borderColor: 'delta.300',
  color: 'white',
  borderRadius: 'base',
  _hover: {
    bg: 'beta.700',
    color: 'white',
  },
  _focus: {
    bg: 'beta.700',
    color: 'white',
  },
  _last: {
    mb: '2',
  },
};

export const IconPerson: CSSObject = {
  boxSize: ['5', null, '6'],
  color: 'white',
  mr: '1.5',
};

export const TextAccordion: CSSObject = {
  fontSize: ['xs', null, 'sm'],
  fontWeight: 'semibold',
  mr: 'auto',
};

export const FlexContactToChange: CSSObject = {
  alignItems: 'center',
  bg: 'beta.700',
  borderRadius: 'md',
  boxShadow: '0px 4px 5px 0px rgba(0, 0, 0, 0.10)',
  color: 'white',
  fontSize: 'xs',
  gap: '1',
  p: '2',
};

export const OverviewAccordionItem: CSSObject = {
  '.chakra-checkbox__label': {
    color: 'gray.600',
  },
  border: 'none',
};
